import { TextField, Autocomplete } from "@material-ui/core";
import { FieldConfig, useField } from "formik";

interface Props extends FieldConfig {
  label?: string;
  data: any[];
  size?: "small" | "medium";
  getOptionLabel?: any;
  dataValueField: string;
  onChange?: (value: any) => void;
  disable?: boolean;
}

const SelectField = ({
  label,
  data,
  dataValueField,
  getOptionLabel,
  onChange,
  size,
  disable = false,
  ...props
}: Props) => {
  const [field, meta, form] = useField(props);
  const { value: selectedValue } = field;

  return (
    <Autocomplete
      noOptionsText="No Data Available"
      value={data.find((x) => x[dataValueField] === selectedValue) || null}
      onChange={(event: any, newValue) => {
        if (onChange) {
          onChange(newValue);
        } else if (newValue !== null) {
          form.setValue(newValue[dataValueField]);
        } else {
          form.setValue(null);
        }
      }}
      options={data}
      disabled={disable}
      size={size}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, value) =>
        option[dataValueField] === value[dataValueField]
      }
      renderInput={(params) => (
        <TextField
          {...params}
          disabled={disable}
          label={label}
          onBlur={field.onBlur}
          {...props}
          helperText={meta.touched && meta.error}
          error={Boolean(meta.touched && meta.error)}
          inputProps={{
            ...params.inputProps,
            form: {
              autocomplete: "off",
            },
          }}
        />
      )}
    />
  );
};

export default SelectField;
